<template>
  <div class="mb-3 mt-3">
    <b-container>
      <b-row>
        <b-col v-if="showError" class="col-12 col-md-6 mb-3">
          <b-card>
            <p v-if="showError === 'not found'" class="text-center">{{ $t('colony.form.not_found') }}</p>
          </b-card>
        </b-col>
      </b-row>
      <div class="d-flex justify-content-around col-md-12"><b-spinner v-if="!loaded && !showError"></b-spinner></div>
      <template v-if="loaded">
        <b-row>
          <b-col class="col-12 col-md-12 mb-3 position-relative">
            <b-card>
              <h1 class="text-primary font-weight-bold text-center">{{ data.title }}</h1>
              <div class="action-row">
                <b-link class="text-body icon-pen text-decoration-none" :title="$t('colony_edit.title')" @click.prevent="checkNetworkUpdate"></b-link>
              </div>
              <div class="action-row-delete">
                <colony-delete :queen="data.queen" :id="id" :apiary="apiary" :formList="false"></colony-delete>
              </div>
            </b-card>
          </b-col>
        </b-row>
        <section class="mb-5" v-if="!isMobile">
          <b-container>
            <b-row class="justify-content-around">
                <b-link class="form-control bg-primary text-light w-auto" :title="$t('colony.export')" @click="downLoadFile()">
                  {{ $t('colony.export') }}
                </b-link>
            </b-row>
          </b-container>
        </section>
        <section class="mb-5">
          <h2 class="text-primary font-weight-bold text-center">{{ $t('colony.queens') }}</h2>
          <queen-list :apiary="apiary" :id="id"></queen-list>
        </section>
        <section class="mb-5">
          <h2 class="text-primary font-weight-bold text-center">{{ $t('colony.ratings') }}</h2>
          <rating-list :id="id" :apiary="apiary"></rating-list>
          <b-row>
            <b-col class="col-6 col-md-6 mb-3">
              <b-link class="bg-transparent text-primary border-primary border form-control w-auto text-center" :title="$t('rating_archive.title')"  @click.prevent="checkNetworkArchiveRating">
                {{ $t('rating_archive.title') }}
              </b-link>
            </b-col>
            <b-col class="col-6 col-md-6 mb-3">
              <b-link class="form-control bg-primary text-light text-center" @click.prevent="checkNetworkCreateRating">{{ $t('rating_create.title') }}</b-link>
            </b-col>
          </b-row>
        </section>
        <section class="mb-5">
          <h2 class="text-primary font-weight-bold text-center">{{ $t('colony.measures') }}</h2>
          <measure-create-buttons :colony="id" :apiary="apiary"></measure-create-buttons>
          <measure-list :id="id" :apiary="apiary"></measure-list>
        </section>
        <section class="mb-5">
          <h2 class="text-primary font-weight-bold text-center">{{ $t('colony.notes') }}</h2>
          <b-col class="col-12 mb-3 position-relative">
            <b-link class="text-body" :title="$t('note_create.title')" @click="checkNetworkCreateNote">
              <b-card class="new h-100">
                <div class="h-100 d-flex flex-column justify-content-around">
                  <h2 class="text-center mb-0">
                    {{ $t('note_create.title') }}
                    <span class="icon-add_filled align-middle" aria-hidden="true"></span>
                  </h2>
                </div>
              </b-card>
            </b-link>
          </b-col>
          <note-list :id="id" :apiary="apiary"></note-list>
        </section>
        <b-modal :id="'offLineModal'" centered hide-header-close @ok="hideModal" class="network-modal">
          <template slot="modal-title">
            {{ $t('offLineModal.title') }}
          </template>
          {{ $t('offLineModal.text') }}
          <template slot="modal-footer" class="offline-modal-footer" slot-scope="{ ok }">
            <b-button size="lg" class="mt-3" @click="ok()">
              {{ $t('offLineModal.ok') }}
            </b-button>
          </template>
        </b-modal>
      </template>
    </b-container>
  </div>
</template>

<script>
import QueenList from '../components/QueenList'
import ColonyDelete from '../components/ColonyDelete'
import MeasureCreateButtons from '../components/MeasureCreateButtons'
import MeasureList from '../components/MeasureList'
import RatingList from '../components/RatingList'
import NoteList from '../components/NoteList'
import axios from 'axios'
import config from '../config'

export default {
  name: 'Colony',
  components: { NoteList, RatingList, MeasureList, MeasureCreateButtons, ColonyDelete, QueenList },
  props: ['id', 'apiary'],
  data () {
    return {
      showError: false,
      loaded: false,
      data: {
        title: null
      }
    }
  },
  methods: {
    checkNetworkUpdate () {
      if (navigator.onLine) {
        this.$router.replace('/colony/edit/' + this.id + '/' + this.apiary)
      } else {
        this.showOffLineModal()
      }
    },
    checkNetworkArchiveRating () {
      if (navigator.onLine) {
        this.$router.replace('/rating/archive/' + this.id + '/' + this.apiary)
      } else {
        this.showOffLineModal()
      }
    },
    checkNetworkCreateRating () {
      if (navigator.onLine) {
        this.$router.replace('/rating/create/' + this.id + '/' + this.apiary)
      } else {
        this.showOffLineModal()
      }
    },
    checkNetworkCreateNote () {
      if (navigator.onLine) {
        this.$router.replace('/note/create/' + this.id + '/' + this.apiary)
      } else {
        this.showOffLineModal()
      }
    },
    showOffLineModal () {
      this.$bvModal.show('offLineModal')
    },
    hideModal () {
      this.$bvModal.hide('offLineModal')
    },
    downLoadFile () {
      const vm = this
      axios({
        url: config.serverUrl + '/csv-export/colony/' + this.id,
        method: 'GET',
        responseType: 'blob'
      }).then((response) => {
        const data = new Blob([response.data])
        const fileURL = window.URL.createObjectURL(data)
        const fileLink = document.createElement('a')

        fileLink.href = fileURL
        fileLink.setAttribute('download', vm.id + '.csv')
        document.body.appendChild(fileLink)

        fileLink.click()
      })
    }
  },
  computed: {
    isMobile () {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
    }
  },
  async mounted () {
    if (this.id) {
      try {
        this.data = await this.$api.colonies.getOne(this.id)
        // console.log(this.data)
        if (this.data) {
          this.loaded = true
        } else {
          this.showError = 'not found'
        }
      } catch (e) {
        this.showError = 'not found'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '../scss/config';

  h1 {
    .icon-pen {
      font-size: 1.5rem;
    }
  }

  a.form-control {
    white-space: nowrap;
    background: #1F7629;
  }

  .action-row {
    position: absolute;
    top: 0;
    right: 0;
    font-size: 1.5rem;
    line-height: 1rem;

    > * {
      display: inline-block;
      padding: 0.5rem 0.75rem;

      &:hover {
        text-decoration: none;
        background-color: $secondary-light;
      }
    }
  }
  .action-row-delete {
    position: absolute;
    bottom: 0;
    right: 0;
    font-size: 1.5rem;
    line-height: 1rem;

    > * {
      display: inline-block;
      padding: 0.5rem 0.75rem;

      &:hover {
        text-decoration: none;
        background-color: $secondary-light;
      }
    }
  }

  .new {
    background-color: $secondary-light;
    font-family: "Roboto Condensed", sans-serif;

    h2 {
      font-size: 1.5rem;
    }
    .card-body {
      padding: 1.25rem;
    }
    .card-body h1{
      font-size: 2rem;
      font-family: $font-family-base;
    }
  }
  .card-body p{
    font-family: $font-family-sans-serif;
  }
  .network-modal {
    font-family: $font-family-sans-serif;
  }
</style>
